// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_14IMXXUS25D7KrEMojzkD-"};